// ./src/components/lists/ListVehicles/index.tsx
import React, { useCallback, useRef, useState } from 'react';

import { FormHandles } from '@unform/core';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';

import {
  Paragraph,
  LoadingList,
  ButtonDefault,
  InputText,
} from '@components/index';
import Car from '@models/Car';
import { apiRebox } from '@services/index';
import { formatText } from '@utils/formatters';

import Item from './Item';

import {
  Container,
  Table,
  Labels,
  Items,
  NothingFound,
  Pagination,
  PaginationGroup,
  FormPage,
  PaginationGroupText,
} from './styles';

interface IProps {
  cars: Car[];
  loading: boolean;
  showTotal: boolean;
  totalValue?: number;
}

const ListCars: React.FC<IProps> = ({
  cars,
  loading,
  showTotal,
  totalValue,
}) => {
  // const { data: getPages } = apiRebox.get(`/cars?per_page=10`);

  // setTotalPages(getPages);
  return (
    <Container>
      <Table>
        <Labels>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Classificação
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Marca
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Modelo
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Status
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Para Rastreador
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Criado em
          </Paragraph>
          <Paragraph
            nameColor="black"
            textAlign="start"
            fontSize={12}
          ></Paragraph>
        </Labels>
        <Items>
          {loading ? (
            <LoadingList loading={loading} />
          ) : (
            <>
              {cars?.length === 0 ? (
                <NothingFound>
                  <Paragraph nameColor="black" opacity={0.6}>
                    Nenhum veículo foi encontrado
                  </Paragraph>
                </NothingFound>
              ) : (
                <>
                  {cars?.map(car => (
                    <Item key={car.id} car={car} />
                  ))}
                </>
              )}
            </>
          )}
        </Items>
        {!loading && showTotal && (
          <Paragraph
            nameColor="black"
            textAlign="end"
            opacity={0.6}
            fontSize={12}
            style={{ margin: '1.5vh 0 0.5vh', fontWeight: 500 }}
          >
            {totalValue === 1
              ? '1 encontrado'
              : `${formatText.numberSeparatedByThousand(
                  totalValue || 0,
                )} encontrados`}
          </Paragraph>
        )}
      </Table>
    </Container>
  );
};

export default ListCars;
